"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jsonp;

var _util = require("../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let CALLBACK_ID = Math.round(Date.now() * Math.random());
const defaultConfig = {
  errorMessage: 'Request Failed!',
  timeoutMessage: 'Request Timeout!',
  timeout: 20000
};
/**
 * call a jsonp request
 * @param {string} api request url
 * @param {object} options jsonp options
 * @param {object} [options.data = {}] request params
 * @param {string} [options.callback] callback search param value
 * @param {string} [options.jsonpCallcack='callback'] callback search param key
 * @param {number} [options.timeout=20000] timeout
 */

function jsonp(api, options) {
  options = _objectSpread({
    callback: "jsonp__".concat(CALLBACK_ID++),
    jsonpCallcack: 'callback',
    timeout: defaultConfig.timeout
  }, options);
  const search = options.query || options.params || options.data || {};
  const callback = search[options.jsonpCallcack] || options.callback;
  search[options.jsonpCallcack] = callback;
  return new Promise((resolve, reject) => {
    const tmp = api.indexOf('?') > -1 ? '&' : '?';
    let script = document.createElement('script');
    script.src = "".concat(api).concat(tmp).concat((0, _util.serialize)(options.query));
    let timmer = setTimeout(() => {
      script.onload = script.onerror = null;
      reject(new Error(defaultConfig.timeoutMessage));
      clear(true);
    }, options.timeout);

    const clear = () => {
      clearTimeout(timmer), timmer = null;
      document.body.removeChild(script);

      window[callback] = () => console.warn("callback ".concat(callback, " has been destroyed!"));

      script = undefined;
    };

    script.onload = () => clear();

    script.onerror = () => {
      clear();
      reject(new Error(defaultConfig.errorMessage));
    };

    window[callback] = data => resolve(data);

    document.body.appendChild(script);
  });
}
/**
 * @param {object} config
 * @param {string} [config.errorMessage]
 * @param {string} [config.timeoutMessage]
 * @param {number} [config.timeout]
 */


jsonp.init = function (config) {
  Object.assign(defaultConfig, config || {});
  jsonp.hasInit = true;
};